import { ActionType, RootState, ServerRequestStatus } from './types';

export const appState = ({ app }: RootState) => app;

export const appStateServerRequests = (state: RootState, actionType: ActionType): ServerRequestStatus =>
  appState(state).server.requests[actionType] || null;

export const routerState = ({ router }: RootState) => router;

export const routerStateLocation = (state: RootState) => routerState(state).location;

export const getStateProject = (state: RootState, projectId: string) =>
  appState(state).projects.find((project) => project._id === projectId);

export const getStatePtw = (state: RootState, ptwId: string) => appState(state).ptws.find((ptw) => ptw._id === ptwId);
